import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/internal/operators';
import { ApiService } from './api.service';

const STORAGE_CURRENT_QUOTE_KEY = 'currentQuote';

@Injectable({
  providedIn: 'root'
})
export class QuoteService {
  constructor(
    private apiService: ApiService,
    private storage: Storage
  ) { }

  async ngOnInit() {
    await this.storage.create();
  }

  rate(order): Observable<any> {
    return this.apiService.rate(order).pipe(
      tap((response) => {
        this.storage.set(STORAGE_CURRENT_QUOTE_KEY, response);
      })
    )
  }

  getCurrentQuote(): Promise<any> {
    return this.storage.get(STORAGE_CURRENT_QUOTE_KEY);
  }


}
